query GetWebFormStarters {
    webFormStarters {
        id
        name
        description
    }
}
